<script setup lang="ts">
function close() {
  document.body.classList.remove('show-headquarters-founders-modal');
}
</script>
<template>
  <div class="bg-white fixed w-full h-full headquarters-founders-modal overflow-y-auto">
    <div class="w-11/12 bg-slate-300 xl:min-h-screen block mx-auto">
      <!-- Section -->
       <div class="block mx-auto">
        <!-- Header -->
          <div class="flex justify-between py-8">
            <div></div>
            <button class="text-lg font-bold hover:underline" @click="close">
              {{ $t('BACK')}} X
            </button>
          </div>
          <div class="flex hero-section items-stretch content-stretch justify-end flex-col lg:flex-row relative 2xl:flex-nowrap">
            <div class="flex-1 flex items-center mb-6 mx-6 xl:mb-0">
              <div class="xl:w-9/12 ml-auto block xl:mr-10">
                <p class="text-4xl xl:text-6xl highlight text-justify my-8">
                  {{ $t('HEADQUARTERS_FOUNDERS') }}
                </p>
                <p class="text-2xl">
                  História da Fundadora do local, Esther Bueno, onde hoje é Terreiro de Umbanda Vó Rita das Almas.
                </p>
              </div>
            </div>
            <div class="relative flex items-end headquarters-founders-img-container justify-end">
              <div class="flex items-end">
                <!-- Image -->
                <img :src="$config.public.assetsUrl + '/about/foto2-esther-bueno.jpg'" alt="Imagem de Esther Bueno">
              </div>
            </div>
          </div>
       </div>
    </div>

    <!-- Content -->
    <div class="content w-11/12 block mx-auto pt-32">
      <div class="block mx-auto w-11/12 lg:w-10/12 2xl:w-8/12 text-2xl pb-8">
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Esther Bueno não acreditava em nada era ateia e tudo começou a mudar quando o filho dela cujo nome era MARIO, que estava internado em um hospital em São Paulo e não melhorava, mesmo tomado toda medicação necessária a sua enfermidade.
        </p>

        <img 
          :src="$config.public.assetsUrl + '/about/foto1-mario.jpg'" 
          alt="Fotografia do Mário" 
          title="Fotografia do Mário"
          class="block mx-auto mb-8"
        >

        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Em um determinado dia quando Dona Esther estava no escritório de contabilidade que ela tinha, começou a conversar com uma colega dela que a convidou para ir em um centro de Umbanda e nesse local quando ela expos a situação do filho dela o responsável pelo centro disse que iria realizar um descarrego no filho dela e assim foi feito.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Para a surpresa de Dona Esther o filho dela teve melhora e recebeu alta do hospital.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Em agradecimento a graça recebida, ela começou a frequentar o centro de Umbanda que através da espiritualidade curou o filho dela; frequentou durante dois anos.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Depois desse período ela se dedicou a estudar a literatura de Kardec, Robson Pinheiro, Da Matta e Silva, Ramatis etc... ela se aprofundou nos estudos, pois viu que a chave para melhora do filho dela era o aprimoramento mediunico, dentro de um centro, terreiro etc....
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          O Filho dela, MARIO, com o tempo a mediunidade aflorou e ele passou a incorporar dentro da residência e em consequência disso ela Dona Esther teve que começar a procurar um local para o MÁRIO aprimorar sua mediunidade; equanto não achava um local que o recebesse ela dentro de sua casa começou a realizar trabalhos mediunicos o que de certa forma começou a ajudar o MARIO.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Para a surpresa da Dona Esther, as dificuldades enfrentadas para achar um local em que seu filho pudesse trabalhar foram imensas, enormes e como ela tinha deixado de frequentar a Umbanda e seguiu para outra vertente,centro espírita, os dirigentes não aceitavam o filho dela, pois, ele incorporava caboclo e preto-velho.         
        </p>

        <img 
          :src="$config.public.assetsUrl + '/about/foto1-esther-bueno.jpg'" 
          alt="Fotografia de Esther Bueno" 
          title="Fotografia de Esther Bueno"
          class="block mx-auto mb-8"
        >

        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Diante de tantas dificuldades enfrentadas em conseguir um local para o MARIO trabalhar, e ela ciente de que não poderia continuar trabalhando espiritualmente dentro de sua casa, dona Esther tomou uma decisão que ela, iria levantar fundos e construir seu próprio local, seu próprio centro.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Dona Esther queria que fosse Umbanda, no entanto, ela não tinha ninguém de confiança e mesmo ela tendo ficado dois anos frequentando a Umbanda, ela considerava muito pouco tempo de aprendizado para tocar um Terreiro e foi quando ela decidiu que seria um local que trabalhasse com desobsessão, pois, esse conhecimento ela dominava e tinha condições de dirigir um trabalho mediunico.  
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Nasce o então sonhado local físico no ano de 2004, Centro Espirita Bezerra de Menezes, voltado ao trabalho de Apometria e desobsessão.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Pelo centro passou valorosos Dirigentes e médiuns que só contribuíram para a solidificação do local, milhares de pessoas foram ajudadas, no período de 2004 a 2019 nos trabalhos de Apometria.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Dona Esther em 2019, foi chamada para voltar ao mundo espiritual, deixando no plano terreno uma grandiosa obra que continuaria, mas em outra vertente, que era o que ela queria desde o inicio.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Em 2019, Eletra Bueno herdeira legal do local físico, conhecendo as qualidades do Pai Noé de Xangô, resolveu realizar o grande sonho de Dona Esther que sempre foi ter um terreiro de Umbanda e assim foi feito.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          A transição foi realizada sob a orientação de Vó Rita das Almas e o Caboclo Cobra Coral e hoje no local encontra-se sediado o Terreiro de Umbanda Vó Rita das Almas, na pratica do bem e da Caridade.
        </p>
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Os dados acima dessa belissima história foi obtida em entrevista com a Senhora Eletra Bueno que também escreveu de próprio punho os acontecimentos. Nossos sinceros e eternos agradecimentos a Esther Bueno que tão maravilhoso legado nos deixou e também a Senhora Eletra Bueno que deu continuidade a toda essa obra.
        </p>


        <img 
          :src="$config.public.assetsUrl + '/about/electra-bueno.jpeg'" 
          alt="Fotografia de Eletra Bueno" 
          title="Fotografia de Eletra Bueno"
          class="block mx-auto mb-1 max-w-80"
        >
        <span class="text-center block text-sm">Eletra Bueno</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.hero-section img {
  border-top-left-radius: 250px;
  width: 85%;
  margin-bottom: -40px;
  max-width: 650px;
}

.content {
  background-color: #f2f0ef;
}

.hero-section {
  min-height: calc(100vh - 132px);
}

.headquarters-founders-img-container {
  pointer-events: none;

  div {    
    height: 50%;
    min-height: 550px;
    width: 100%;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-height: 580px;
  }
}


.headquarters-founders-modal {
  z-index: 1000 !important;
  line-height: 1;
  transform: scale(1.1);
  opacity: 0;
  visibility: hidden;

  .full-text {
    line-height: 1.8;
  }

  .highlight {
    line-height: 1.5;
  }
}


@media (screen(lg)) {
  .headquarters-founders-img-container div {
    transform: translateX(52px);
  }
}

@media (screen(xl)) {
  .headquarters-founders-img-container div {
    transform: translateX(60px);
  }
}

@media screen and (max-width: 1022px) {
  .hero-section {
    min-height: 700px !important;
    height: unset !important;
  }
}

@media (screen(2xl)) {
  .headquarters-founders-img-container {
    width: 600px;

    div {
      transform: translateX(19%);
    }
    
  }
}

@media (screen(xl)) {
  .hero-section {
    img {
      width: 100%;
      height: 100%;
    }
  }
}


@media screen and (min-width: 550px) {
  .headquarters-founders-img-container div {
    min-width: 420px;
    width: unset;
  }
}

</style>